import { useNavigate } from "react-router-dom"

import DefaultButton from "shared/ui/DefaultButton"
import Style from "./style"

import usePostPaymentConfirm from "entity/payment/usePostPaymentConfirm"
import timestampCalculator from "shared/lib/timestampCalculator"
import convertMoney from "shared/lib/convertMoney"

const PaymentDone = () => {
    const navigate = useNavigate()

    const [paymentResult] = usePostPaymentConfirm()

    return (
        <Style.Wrapper>

            {!paymentResult
                ? <Style.Header>
                    <img src="https://static.toss.im/lotties/loading-spot-apng.png" width="120" height="120" />
                    <h2>결제를 승인하는 중이에요</h2>
                </Style.Header>
                : paymentResult?.statusCode === 200
                    ? <>
                        <Style.Header>
                            <img src="https://static.toss.im/illusts/check-blue-spot-ending-frame.png" width="120" height="120" />
                            <h2>결제를 완료했어요</h2>
                        </Style.Header>

                        <Style.ContentDiv>
                            <Style.Area>
                                <h2>구매 상품</h2>
                                <p>{paymentResult?.data?.name}</p>
                            </Style.Area>
                            <Style.Area>
                                <h2>결제 금액</h2>
                                <p>{convertMoney(paymentResult?.data?.total_price)} KRW</p>
                            </Style.Area>
                            <Style.Area>
                                <h2>주문 번호</h2>
                                <p>{paymentResult?.data?.order_id}</p>
                            </Style.Area>
                            <Style.Area>
                                <h2>결제 일시</h2>
                                <p>{timestampCalculator(paymentResult?.data?.approve_at)}</p>
                            </Style.Area>
                        </Style.ContentDiv>

                        <Style.Area>
                            {paymentResult?.data?.type === "exam" &&
                                <DefaultButton clickEvent={() => navigate("/my/tryout/record")}>응시하러 가기</DefaultButton>
                            }
                            {paymentResult?.data?.type === "event" &&
                                <Style.Notice>트라이아웃 대회 참가권이 발행되었습니다.</Style.Notice>
                            }
                            <DefaultButton deactive clickEvent={() => window.location.href = paymentResult?.data?.recipe_url}>결제 영수증 보기</DefaultButton>
                        </Style.Area>
                    </>
                    : <>
                        <Style.Header>
                            <img src="https://static.toss.im/lotties/error-spot-apng.png" width="120" height="120" />
                            <h2 className="title">{paymentResult?.data?.message}</h2>
                        </Style.Header>

                        <Style.ContentDiv>
                            <Style.Area>
                                <h2>에러 코드</h2>
                                <p>{paymentResult?.data?.error_code}</p>
                            </Style.Area>
                        </Style.ContentDiv>
                    </>
            }
        </Style.Wrapper>
    );
}

export default PaymentDone